import { observer } from 'mobx-react-lite'
import { Button, Typography } from 'shared/ui'
import { type AircallNumbersListStore } from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationAircallSettings/store/AircallNumbersListStore'

import styles from './styles.module.scss'

type IUpdateAircallNumbersLayoutProps = {
  store: AircallNumbersListStore
}

export const UpdateAircallNumbersLayout = observer(
  ({ store }: IUpdateAircallNumbersLayoutProps) => {
    const { loading, isRefreshDisabled, importButtonLabel, refreshNumbers } = store

    return (
      <div className={styles.empty}>
        <div className={styles.block}>
          <Typography ariaLabel={'Import Aircall numbers'} variant={'body-rg-medium'}>
            Import Aircall numbers
          </Typography>
          <Typography
            ariaLabel={'desc'}
            variant={'body-md-regular'}
            color={'tertiary'}
            className={styles.desc}
          >
            If you have available Aircall numbers, you can <br /> bring them into Salesmsg
          </Typography>
        </div>
        <Button
          text={importButtonLabel}
          contained={'tertiary'}
          size={'medium'}
          onClick={refreshNumbers}
          disabled={isRefreshDisabled}
          icon={loading ? 'loading3' : 'refresh'}
        />
      </div>
    )
  }
)
